module.exports = __webpack_public_path__ + "static/img/6.33601a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/6.png
// module id = cRVr
// module chunks = 0